import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { ExperimentControlsWidgetModule } from './components/experiment-controls-widget.module';
import { ABExperimentsService } from './services/ABExperiments.service';

@NgModule({
	declarations: [],
	imports: [CommonModule, ExperimentControlsWidgetModule],
	exports: [],
	providers: [ABExperimentsService],
})
export class ExperimentModule {}
